import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackNextVirtualTour = (virtualTourIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'next virtual tour',
        eventValue: virtualTourIndex + 1
    });
};

export const trackPreviousVirtualTour = (virtualTourIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'previous virtual tour',
        eventValue: virtualTourIndex + 1
    });
};

export const trackExternalVirtualTour = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickout',
        eventLabel: 'virtual tour link'
    });
};
